import "core-js/modules/es.array.push.js";
import { FormikEvent } from "../../core/components/FormikEvent";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import ModalActionBar from "../../core/components/Modal/ModalActionBar";
import ModalHeader from "../../core/components/Modal/ModalHeader";
import { Formik } from 'formik';
import { useMemo } from 'react';
import styled from 'styled-components';
import { Box, Button, Modal, tombac } from 'tombac';
import { object, string } from 'yup';
import { ProductLogo } from "./ProductLogo";
import { getLimitEditorComponent } from "./limit-editors";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorWrapper = styled.div.withConfig({
  displayName: "LimitsConfiguratorModal__EditorWrapper"
})(["padding:", ";& + &{border-top:", ";}"], tombac.space(3), tombac.parse('1u solid --neutral-400'));

/**
 * This component is going to replace LimitsConfigurator component at some point.
 * For now, it is used only for editing shared limits.
 */
export const LimitsConfiguratorModal = _ref => {
  let {
    append,
    isLoading,
    isOpen,
    limits,
    onChange,
    onSubmit,
    onRequestClose,
    schemas
  } = _ref;
  const limitComponents = [];
  if (!isLoading) {
    schemas.forEach(schema => {
      const LimitComponent = getLimitEditorComponent(schema.type);
      limitComponents.push(LimitComponent);
    });
  }

  // Formik requires the initial value for every field to enable validation on submit
  const initialLimits = useMemo(() => schemas ? {
    ...Object.fromEntries(schemas.map(_ref2 => {
      let {
        name
      } = _ref2;
      return [name, undefined];
    })),
    ...limits
  } : {}, [limits, schemas]);
  const validationSchema = useMemo(() => schemas && object(Object.fromEntries(schemas.map(_ref3 => {
    let {
      name,
      required
    } = _ref3;
    return [name, required ? string().ensure().trim().required('The limit value is required') : undefined];
  }))), [schemas]);
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "LimitsConfiguratorModal",
    "data-sentry-source-file": "LimitsConfiguratorModal.tsx",
    children: [/*#__PURE__*/_jsx(ModalHeader, {
      image: /*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        children: [/*#__PURE__*/_jsx(ProductLogo, {
          height: "32",
          productId: "ts",
          width: "32"
        }), /*#__PURE__*/_jsx(Box, {
          $ml: "-2sp",
          $mt: "2sp",
          children: /*#__PURE__*/_jsx(ProductLogo, {
            height: "32",
            productId: "od",
            width: "32"
          })
        })]
      }),
      primaryTitle: "Set shared limits",
      secondaryTitle: "Traffic Stats & O/D Analysis",
      "data-sentry-element": "ModalHeader",
      "data-sentry-source-file": "LimitsConfiguratorModal.tsx",
      "data-sentry-element": "ModalHeader"
    }), isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      $minHeight: "15sp"
    }) : /*#__PURE__*/_jsx(Formik, {
      initialValues: initialLimits,
      onSubmit: onSubmit,
      validateOnMount: true,
      validationSchema: validationSchema,
      children: _ref4 => {
        let {
          handleSubmit,
          isSubmitting
        } = _ref4;
        return /*#__PURE__*/_jsxs("form", {
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/_jsx(FormikEvent, {
            onChange: onChange
          }), /*#__PURE__*/_jsxs(Box, {
            children: [limitComponents.map((LimitComponent, index) => {
              if (LimitComponent === null) return null;
              const schema = schemas[index];
              return /*#__PURE__*/_jsx(EditorWrapper, {
                children: /*#__PURE__*/_jsx(LimitComponent, {
                  label: schema.label,
                  isSharedLimit: true,
                  schema: schema
                })
              }, schema.name);
            }), append]
          }), /*#__PURE__*/_jsxs(ModalActionBar, {
            children: [/*#__PURE__*/_jsx(Button, {
              onClick: onRequestClose,
              type: "button",
              variant: "flat",
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              $ml: "1sp",
              busy: isSubmitting,
              disabled: !isOpen,
              type: "submit",
              variant: "primary",
              children: "Save"
            })]
          })]
        });
      }
    })]
  });
};